
function SystemStateReport() {
    /// <summary>
    /// This object provides js functions for the Widget.Admin.SystemStateReport.js. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 31.5.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
        /// **********************************************************************<br />
    /// *** v1.1.0 - 31.5.2022                                               *<br />
    /// **********************************************************************<br />
    /// * - added ticket list                                                *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 28.6.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
}

SystemStateReport.prototype = new vcTemplate();

SystemStateReport.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;

    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
        //set the correct width
        me.visual.find("#div-data").width(me.width - parseInt(me.visual.find(".vc-list").width(),10)-18);
        //... and height
        me.visual.find("#div-menu,.vc-list, #div-data").height(me.height);
     
        me.visual.find("#div-btn-new").off("click").on("click", function () { me.clear(); me.select($(this)); }).button();
        me.visual.find("#div-btn-save").off("click").on("click", function () {me.save(); }).button();
        me.visual.find("#div-btn-del").off("click").on("click", function () { me.del(); }).button();
        me.visual.find(".vc-list-table").off("click", ".vc-list-item").on("click", ".vc-list-item", function () { me.select($(this)); });
      
        me.visual.find(".button-toggle").off("click").on("click", function () { me.toggleMenu($(this)); }).button();

        me.visual.find("#div-user").off("change").on("change", function () {
            me.config = { Uid: parseInt(me.visual.find("#ddl-user").val()), Operations: [] };
            me.generateTicketList();
        });



       
        me.visual.find("#div-tickets-btn-new").off("click").on("click", function () {
            if (me.visual.find("#div-tickets-list .tickets-tpl").length === 0) {
                me.visual.find("#div-tickets-list").html("");
            }
            var tpl = me.visual.find("#div-tickets-template").clone();
            tpl.show();
            me.visual.find("#div-tickets-list").append(tpl);

        }).button();
        me.visual.find("#div-tickets-list").off("click", ".tickets-del").on("click", ".tickets-del", function (e) {

            $(e.target).parents(".tickets-tpl").remove();
        
        });

        //get the entries
        me.fetchEntries();
    return true;
    } catch (ex) { me.writeError('init', ex); return false }
}

SystemStateReport.prototype.fetchEntries = function () {
    /// <summary>
    ///  This function fetches all existing entries and generates the entry list. 
    /// </summary>
    var me = this;
    var sTmp;
    try {
        if (me.error) {
            return false;
        }
        me.visual.find(".vc-list-item").removeClass("selected");
        me.visual.find(".vc-list-table").html("");
        me.visual.find("#div-data").hide();

        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({typeId:1}),
       function (result) {
 
           if (result === null) { me.showMessage(me.resources.err_loadData, true); return false; }
           if (result.rows.count === 0) { me.showMessage(me.resources.noEntriesExist, false); return false; }
           for (var i = 0; i < result.rows.length; i++) {
   
               sTmp = "<li class='vc-list-item'  data-id='" + result.rows[i].id + "' data-active='" + result.rows[i].active + "' data-uid='" + result.rows[i].uid + "' data-cid='" + result.rows[i].cid + "' data-config='" + result.rows[i].config + "' >";
               if (result.rows[i].active) {
                   sTmp += "<i class='fa fa-check icon-color-ok vc-list-icon'></i> ";
               } else {
                   sTmp += "<i class='fa-regular fa-times-circle icon-color-error vc-list-icon'></i> ";
               }
               sTmp += result.rows[i].lastname +", " +result.rows[i].firstname + " (" +result.rows[i].username +")</li>";
               me.visual.find(".vc-list-table").append(sTmp);
           }
           me.visual.find(".vc-list-table .vc-list-item:odd").addClass("alt");
           me.clear();
           return true;
       });

        return true;
    } catch (ex) { me.writeError('fetchEntries', ex); return false }

}

SystemStateReport.prototype.toggleMenu = function (obj) {
    /// <summary>
    ///  This function clears all settings.
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        var type = parseInt(obj.data("type"));
        me.visual.find(".toggle-areas.button-toggle").removeClass("button-toggle-active");
        obj.addClass("button-toggle-active");
      

        if (type == 0) {
            me.visual.find("#div-systemstatereport").hide();
            me.visual.find("#div-tickets").show();
        } else {
            me.visual.find("#div-systemstatereport").show();
            me.visual.find("#div-tickets").hide();
        }

        return true;
    } catch (ex) { me.writeError('clear', ex); return false }
}

SystemStateReport.prototype.clear = function () {
    /// <summary>
    ///  This function clears all settings.
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
       
        me.visual.find("#chk-active").prop("checked", false);
        me.visual.find("#ddl-user").val(-1);
        me.visual.find("#ddl-bec").val(-1);
        me.visual.find(".chk").prop("checked", false);
        me.visual.find(".txtEnabled").val(0);
        return true;
    } catch (ex) { me.writeError('clear', ex); return false }
}

SystemStateReport.prototype.select = function (obj) {
    /// <summary>
    ///  This function sets all settings for the selected entry.
    /// </summary>
    var me = this;
  
    try {
        if (me.error) { return false; }
      

        me.visual.find("#div-data").show();
        me.visual.find(".vc-list-item").removeClass("selected");
        me.visual.find("#chk-active").prop("checked", obj.data("active"));
        me.visual.find("#ddl-user").val(obj.data("uid"));
       
        me.visual.find("#ddl-bec").val(obj.data("cid"));
        //if the id=-1 then we have a new entry - we don't have to set the config
        if (parseInt(obj.data("id"), 10) === -1) {
            me.visual.find("#div-user").show();
            me.visual.find("#div-btn-del").hide();
            return true;
        } else {
            me.visual.find("#div-btn-del").show();
            obj.addClass("selected");
            me.visual.find("#div-user").hide();
        }

    

        me.config = obj.data("config");
      

        if (typeof (me.config.ContactType) !== "undefined") {
            me.visual.find("#ddl-contactType").val(me.config.ContactType);
        }
        me.setWeekdays("div-week-alarm", me.config.Alarms);
        me.setWeekdays("div-week-unit", me.config.InvalidUnits);
        me.setWeekdays("div-week-invalid-signal", me.config.InvalidSignals);
        me.visual.find("#txt-interval-invalid-signal").val(me.config.InvalidSignalsInterval);
        me.setWeekdays("div-week-inplausible-signal", me.config.InplausibleSignals);
        me.visual.find("#txt-interval-inplausible-signal").val(me.config.InplausibleSignalsInterval);
        me.setWeekdays("div-week-missing-signal", me.config.MissingSignals);
        me.visual.find("#txt-interval-missing-signal").val(me.config.MissingSignalsInterval);
        me.setWeekdays("div-week-web-error", me.config.WebErrors);
        me.visual.find("#txt-interval-web-error").val(me.config.WebErrorsInterval);

        me.generateTicketList();

        return true;
    } catch (ex) { me.writeError('select', ex); return false }

}

SystemStateReport.prototype.generateTicketList = function () {
    /// <summary>
    ///  This function sets all settings for the selected entry.
    /// </summary>
    var me = this;
   
    try {

     

        if (me.error) { return false; }


        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ typeId: 2, uid: me.config.Uid }),
            function (projects) {
             
                if (projects === null) { me.showMessage(me.resources.err_loadData, true); return false; }
                if (projects.rows.count === 0) { me.showMessage(me.resources.noEntriesExist, false); return false; }



                var ddlProjects = me.visual.find("#div-tickets-template #ddl-ticket-project");
                ddlProjects.empty();
                ddlProjects.append($('<option>', { value: -1, text: me.resources.all_lbl }, '</option>'));
            

                for (var i = 0; i < projects.rows.length; i++) {
                  
                    ddlProjects.append(
                        $('<option>', {
                            value: projects.rows[i].id,
                            text: projects.rows[i].name
                        }, '</option>'));

                }

                me.visual.find("#div-tickets-list").html("");
                if (me.config.Operations.length == 0) {
                    me.visual.find("#div-tickets-list").html($("<div>").addClass("note").css("width", "100%").html(me.resources.noEntriesExist));
                } else {

                    me.visual.find("#div-tickets-list").html("");



                    $.each(me.config.Operations, function (i, item) {
                        var tpl = me.visual.find("#div-tickets-template").clone();
                     
                        tpl.find("#ddl-ticket-interval").val(item.Interval);
                        tpl.find("#ddl-ticket-filter").val(item.FilterId);

                        tpl.find("#ddl-ticket-project").val(item.Blid);
                        tpl.show();
                        me.visual.find("#div-tickets-list").append(tpl);
                    });
                }

             

                return true;
            });



        return true;
    } catch (ex) { me.writeError('generateTicketList', ex); return false }

}

SystemStateReport.prototype.setWeekdays = function (id, lst) {
    /// <summary>
    ///  This function sets the configuration for one single weekday control.
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        me.visual.find("#" + id + " .chk").prop("checked", false);
        for (var i = 0; i < lst.length; i++) { me.visual.find("#" + id +" .chk[data-id='" + lst[i] + "']").prop("checked", true); }
        return true;
    } catch (ex) { me.writeError('select', ex); return false }

}

SystemStateReport.prototype.save = function () {
    /// <summary>
    ///  This function generates the new config object and sends the save request. 
    /// </summary>
    var me = this;
    var config = {};
    var id = -1;
    try {
        if (me.error) { return false;}

        me.visual.find(".txtEnabled").removeClass("error");

        id = parseInt(me.visual.find(".vc-list-item.selected").data("id"), 10);
        //if no item is selected we have a new entry 
        if (isNaN(id)) { id = -1; }
       
        config.Active = me.visual.find("#chk-active").prop("checked");
        config.Uid = me.visual.find("#ddl-user").val();
        config.Cid = me.visual.find("#ddl-bec").val();
        config.ContactType = me.visual.find("#ddl-contactType").val();
        config.Alarms = [];
        me.visual.find("#div-week-alarm .chk:checked").each(function() { config.Alarms.push($(this).data("id"));});
        config.InvalidUnits = [];
        me.visual.find("#div-week-unit .chk:checked").each(function () { config.InvalidUnits.push($(this).data("id")); });
        config.InvalidSignals = [];
        me.visual.find("#div-week-invalid-signal .chk:checked").each(function () { config.InvalidSignals.push($(this).data("id")); });
        config.InvalidSignalsInterval = parseInt(me.visual.find("#txt-interval-invalid-signal").val(),10);
        if (isNaN(config.InvalidSignalsInterval)) {me.visual.find("#txt-interval-invalid-signal").addClass("error");return true;}
        config.InplausibleSignals = [];
        me.visual.find("#div-week-inplausible-signal .chk:checked").each(function () { config.InplausibleSignals.push($(this).data("id")); });
        config.InplausibleSignalsInterval = parseInt(me.visual.find("#txt-interval-inplausible-signal").val(), 10);
        if (isNaN(config.InplausibleSignalsInterval)) { me.visual.find("#txt-interval-inplausible-signal").addClass("error"); return true; }
        config.MissingSignals = [];
        me.visual.find("#div-week-missing-signal .chk:checked").each(function () { config.MissingSignals.push($(this).data("id")); });
        config.MissingSignalsInterval = parseInt(me.visual.find("#txt-interval-missing-signal").val(), 10);
        if (isNaN(config.MissingSignalsInterval)) { me.visual.find("#txt-interval-missing-signal").addClass("error"); return true; }
        config.MissingSignals = [];
        me.visual.find("#div-week-missing-signal .chk:checked").each(function () { config.MissingSignals.push($(this).data("id")); });
       
        config.WebErrors = [];
        me.visual.find("#div-week-web-error .chk:checked").each(function () { config.WebErrors.push($(this).data("id")); });
        config.WebErrorsInterval = parseInt(me.visual.find("#txt-interval-web-error").val(), 10);
        if (isNaN(config.WebErrorsInterval)) { me.visual.find("#txt-interval-web-error").addClass("error"); return true; }

        var tickets = me.visual.find("#div-tickets-list .tickets-tpl");
        config.Operations = [];
        $.each(tickets, function (i, item) {
            config.Operations.push({ interval: $(item).find("#ddl-ticket-interval").val(), FilterId: $(item).find("#ddl-ticket-filter").val(),  Blid: $(item).find("#ddl-ticket-project").val()  });
        });

     


        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ 'type': 0, "id":id, "config":config }),
       function (result) {
           if (result === false) { me.showMessage(me.resources.err_saveData, true); return false; }
           me.fetchEntries();
           return true;
       });

        return true;
    } catch (ex) { me.writeError('save', ex); return false }

}

SystemStateReport.prototype.del = function () {
    /// <summary>
    ///  This function sends the delete request.
    /// </summary>
    var me = this;
    var id;
    try {
        if (me.error) { return false; }

        id = parseInt(me.visual.find(".vc-list-item.selected").data("id"), 10);
        if (isNaN(id)) {
            me.showMessage(me.resources.err_saveData, true);
            return false;
        }
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ 'type': 1, "id": id}),
       function (result) {
           if (result === false) { me.showMessage(me.resources.err_saveData, true); return false; }
           me.fetchEntries();
           return true;
       });

        return true;
    } catch (ex) { me.writeError('del', ex); return false }

}

SystemStateReport.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find(".vc-list, #div-data").hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};


